import {
  Bank,
  AccountMultiple,
  AccountSwitch,
  ChartLineVariant,
  ChartTimeline,
  ClipboardTextOutline,
  FileDocumentOutline,
  SchoolOutline,
  ThumbUpOutline
} from 'mdi-material-ui'
import { FeatureCodes, moduleKeys } from 'src/components/common/featureData'

const redirectUri = process.env.NEXT_PUBLIC_USER_REDIRECT_URL

export const misMenu = {
  [FeatureCodes.MIS.nlrdReport]: {
    title: 'NLRD Report',
    icon: FileDocumentOutline,
    module: moduleKeys.misreport,
    children: [
      {
        title: 'NLRD Dashboard',
        path: `${redirectUri}enrolment/mis-report/nlrd/dashboard`
      },
      {
        title: 'NLRD Data',
        path: `${redirectUri}enrolment/mis-report/nlrd/data`
      }
    ]
  },
  [FeatureCodes.MIS.dhetReport]: {
    title: 'DHET Report',
    icon: FileDocumentOutline,
    module: moduleKeys.misreport,
    children: [
      {
        title: 'DHET Dashboard',
        path: `${redirectUri}enrolment/mis-report/dhet/dashboard`
      },
      {
        title: 'DHET Data',
        path: `${redirectUri}enrolment/mis-report/dhet/data`
      }
    ]
  },
  [FeatureCodes.MIS.graduationReport]: {
    title: 'Graduation Report',
    icon: SchoolOutline,
    module: moduleKeys.misreport,
    children: [
      {
        title: 'Graduation Dashboard',
        path: `${redirectUri}enrolment/mis-report/graduation/dashboard`
      },
      {
        title: 'Graduation Data',
        path: `${redirectUri}enrolment/mis-report/graduation/data`
      }
    ]
  },
  [FeatureCodes.MIS.throughputRate]: {
    title: 'Throughput Rate',
    icon: ChartTimeline,
    module: moduleKeys.misreport,
    children: [
      {
        title: 'Throughput Dashboard',
        path: `${redirectUri}enrolment/mis-report/throughput/dashboard`
      },
      {
        title: 'Throughput Data',
        path: `${redirectUri}enrolment/mis-report/throughput/data`
      }
    ]
  },
  [FeatureCodes.MIS.progressionRate]: {
    title: 'Progression Rate',
    icon: ChartLineVariant,
    module: moduleKeys.misreport,
    children: [
      {
        title: 'Progression Dashboard',
        path: `${redirectUri}enrolment/mis-report/progression/dashboard`
      },
      {
        title: 'Progression Data',
        path: `${redirectUri}enrolment/mis-report/progression/data`
      }
    ]
  },
  [FeatureCodes.MIS.successRate]: {
    title: 'Success Rate',
    icon: ThumbUpOutline,
    module: moduleKeys.misreport,
    children: [
      {
        title: 'Success Dashboard',
        path: `${redirectUri}enrolment/mis-report/success/dashboard`
      },
      {
        title: 'Success Data',
        path: `${redirectUri}enrolment/mis-report/success/data`
      }
    ]
  },
  [FeatureCodes.MIS.statusReport]: {
    title: 'Status Report',
    icon: AccountMultiple,
    module: moduleKeys.misreport,
    children: [
      {
        title: 'Status Dashboard',
        path: `${redirectUri}enrolment/mis-report/status/dashboard`
      },
      {
        title: 'Status Data',
        path: `${redirectUri}enrolment/mis-report/status/data`
      }
    ]
  },
  [FeatureCodes.MIS.rolloverReport]: {
    title: 'Rollover Report',
    icon: AccountSwitch,
    module: moduleKeys.misreport,
    children: [
      {
        title: 'Rollover Dashboard',
        path: `${redirectUri}enrolment/mis-report/rollover/dashboard`
      },
      {
        title: 'Rollover Data',
        path: `${redirectUri}enrolment/mis-report/rollover/data`
      }
    ]
  },
  [FeatureCodes.MIS.admissionReport]: {
    title: 'Admission Report',
    icon: Bank,
    module: moduleKeys.misreport,
    children: [
      {
        title: 'Admission Dashboard',
        path: `${redirectUri}enrolment/mis-report/admission/dashboard`
      },
      {
        title: 'Admission Data',
        path: `${redirectUri}enrolment/mis-report/admission/data`
      }
    ]
  },
  [FeatureCodes.MIS.assessmentReport]: {
    title: 'Assessment Report',
    icon: ClipboardTextOutline,
    module: moduleKeys.misreport,
    children: [
      {
        title: 'Assessment Dashboard',
        path: `${redirectUri}enrolment/mis-report/assessment/dashboard`
      },
      {
        title: 'Assessment Data',
        path: `${redirectUri}enrolment/mis-report/assessment/data`
      }
    ]
  }
}
